import Col from './Col';
import Row from './Row';
import Layout, { Header, Footer, Content } from './Layout';
import Container from './Container';
import Sider from './Sider';
export { Col, Row };
Layout.Header = Header;
Layout.Footer = Footer;
Layout.Content = Content;
Layout.Sider = Sider;
Layout.Container = Container;
export default Layout;


// WEBPACK FOOTER //
// ./~/@tinper/next-ui/lib/wui-layout/src/index.js